import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Helper: Tarayıcı uyumlu scroll pozisyonu alma
const getScrollTop = () => {
    return (
        (document.scrollingElement && document.scrollingElement.scrollTop) ||
        window.scrollY ||
        (document.documentElement && document.documentElement.scrollTop) ||
        (document.body && document.body.scrollTop) ||
        0
    );
};

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [, setScrollTop] = useState(getScrollTop());
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const ticking = useRef(false);
    const prevScrolledRef = useRef(false);

    // Mobil eşik - mobilde gösterim kontrolü
    const MOBILE_BREAKPOINT = 768;
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false);

    // Resize dinleyicisi: isMobile güncelle
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    // Ayarlamak istediğin eşik değerini buradan değiştirebilirsin
    const THRESHOLD = 10;

    useEffect(() => {
        const options = { passive: true };

        // Sayfa yüklendiğinde mevcut konumu kontrol et
        const initialScroll = getScrollTop();
        const initialIsScrolled = initialScroll > THRESHOLD;

        prevScrolledRef.current = initialIsScrolled;
        setScrolled(initialIsScrolled);

        // İç elementlerden gelen scroll'u yakalamak için ancestor bulucu
        const findScrollableAncestor = (node) => {
            let el = node;
            while (el && el !== document.body && el !== document.documentElement) {
                try {
                    if (el.scrollHeight > el.clientHeight) {
                        return el;
                    }
                } catch (err) {
                    // Erişim hatası ihtimaline karşı
                }
                el = el.parentElement;
            }
            return document.scrollingElement || document.documentElement || document.body;
        };

        const onAnyScroll = (e) => {
            if (!ticking.current) {
                ticking.current = true;
                window.requestAnimationFrame(() => {
                    let currentTop;

                    // Event target kontrolü
                    const tgt = e && e.target ? e.target : document;
                    if (tgt instanceof Element) {
                        const scrollable = findScrollableAncestor(tgt);
                        try {
                            currentTop = scrollable.scrollTop || 0;
                        } catch (err) {
                            currentTop = getScrollTop();
                        }
                    } else {
                        currentTop = getScrollTop();
                    }

                    // 10 piksel kontrolü burada yapılıyor
                    const isScrolled = currentTop > THRESHOLD;

                    if (isScrolled !== prevScrolledRef.current) {
                        setScrolled(isScrolled);
                        prevScrolledRef.current = isScrolled;
                    }

                    setScrollTop(currentTop);
                    ticking.current = false;
                });
            }
        };

        // Hem ana pencereyi hem de doküman üzerindeki kaydırmaları dinle
        window.addEventListener("scroll", onAnyScroll, options);
        document.addEventListener("scroll", onAnyScroll, { capture: true, passive: true });

        return () => {
            window.removeEventListener("scroll", onAnyScroll, options);
            document.removeEventListener("scroll", onAnyScroll, { capture: true, passive: true });
        };
    }, []);

    return (
        <div className={`header ${scrolled ? "header-scrolled" : ""} ${mobileMenuOpen ? "menu-open" : ""}`}>
            <div className="container">
                <div className="menu">
                    <Link to={"/"} className="logo" onClick={() => setMobileMenuOpen(false)}>
                        <img src={process.env.PUBLIC_URL + "/images/logo-beyazrenkli.png"} alt="Logo" />
                    </Link>

                    <div className={`menu-container ${mobileMenuOpen ? 'active' : ''}`}>
                        {/* Mobilde toggle menüde en üstte logo - sadece mobil görünümde ve menü açıkken göster */}
                        {mobileMenuOpen && isMobile && (
                            <div className="mobile-menu-logo" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1.5rem'}}>
                                <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                                    <img src={process.env.PUBLIC_URL + "/images/logo-beyazrenkli.png"} alt="Logo" style={{height: 44, maxWidth: 160}} />
                                </Link>
                            </div>
                        )}
                        {/* Menü linkleri */}
                        <Link to={"/programlar"} className="menu-item" onClick={() => setMobileMenuOpen(false)}>
                            <svg className="menu-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                <rect x="2" y="5" width="20" height="12" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                <path d="M8 21h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                            PROGRAMLAR
                        </Link>
                        <Link to={"/obb-tv-haber"} className="menu-item" onClick={() => setMobileMenuOpen(false)}>
                            <svg className="menu-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                <rect x="3" y="4" width="18" height="16" rx="1" ry="1" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                <path d="M7 8h10M7 12h10M7 16h6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                            </svg>
                            OBB TV HABERLER
                        </Link>
                        <Link to={"/yayin-akisi"} className="menu-item" onClick={() => setMobileMenuOpen(false)}>
                            <svg className="menu-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                <rect x="3" y="5" width="18" height="16" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                <path d="M8 3v4M16 3v4M3 11h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                            YAYIN AKIŞI
                        </Link>
                        <Link to={"/kurumsal"} className="menu-item" onClick={() => setMobileMenuOpen(false)}>
                            <svg className="menu-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                <path d="M3 21h18V8L12 3 3 8v13z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                                <path d="M9 10v6M15 10v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                            KURUMSAL
                        </Link>
                        <Link to={"/sehir-kameralari"} className="menu-item" onClick={() => setMobileMenuOpen(false)}>
                            <svg className="menu-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                <rect x="2" y="6" width="18" height="12" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.5" />
                            </svg>
                            ŞEHİR KAMERALARI
                        </Link>
                        {/* Mobilde Canlı Yayın linki */}
                        <Link to={"/canli-yayin"} className="menu-item mobile-live" onClick={() => setMobileMenuOpen(false)}>
                            <span className="live-dot"></span>
                            CANLI YAYIN
                        </Link>
                    </div>

                    {/* Modern Hamburger Toggle */}
                    <button
                        className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        aria-label="Menüyü aç/kapat"
                        aria-expanded={mobileMenuOpen}
                    >
                        <span className="hamburger-box">
                            <span className="hamburger-inner"></span>
                        </span>
                    </button>
                </div>
                <div className="right desktop-only">
                    <Link
                        to={"/canli-yayin"}
                        className="item live-btn"
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        <span className="live-dot"></span>
                        CANLI YAYIN
                    </Link>
                </div>
            </div>

            {/* Mobil menü açıkken arka plan overlay */}
            {mobileMenuOpen && (
                <div className="menu-overlay" onClick={() => setMobileMenuOpen(false)}></div>
            )}
        </div>
    );
};

export default Header;

